export enum SortFieldsRecord {
  BookingTimeFrom = 'booking_time_from',
  Status = 'status',
  ServiceType = 'service_type'
}
